import axios from 'axios';
import { Apiurl } from './apirest';

const LOCATION_API = `${Apiurl}zonas/`;

const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return { headers: { Authorization: `Bearer ${token}` } };
};

const LocationService = {
    // Fetch full hierarchy (useful for replacing the big object initially)
    getHierarchy: async () => {
        try {
            const response = await axios.get(`${Apiurl}zonas/municipios/hierarchy/`, getAuthHeader());
            return response.data;
        } catch (error) {
            console.error("Error fetching location hierarchy", error);
            return {};
        }
    },

    getMunicipios: async () => {
        try {
            const response = await axios.get(`${LOCATION_API}municipios/`, getAuthHeader());
            return response.data;
        } catch (error) {
            console.error("Error fetching municipios", error);
            return [];
        }
    },

    getZonasByMunicipio: async (municipioId) => {
        try {
            const response = await axios.get(`${LOCATION_API}zonas/?municipio=${municipioId}`, getAuthHeader());
            return response.data;
        } catch (error) {
            console.error("Error fetching zonas", error);
            return [];
        }
    },

    getLugaresByZona: async (zonaId) => {
        try {
            const response = await axios.get(`${LOCATION_API}lugares/?zona=${zonaId}`, getAuthHeader());
            return response.data;
        } catch (error) {
            console.error("Error fetching lugares", error);
            return [];
        }
    }
};

export default LocationService;
